<ifc-app-scroll-container>
  <article class="container">
    <header class="header">
      <h2 class="heading">Verify your identity</h2>
      <p>We need to confirm your identity before providing you with your funds.</p>
      <p>These questions help us protect you from fraud and identity theft.
        Avoid closing your browser, hitting the refresh button, or leaving the screen before clicking on continue.</p>
    </header>
    <mat-divider></mat-divider>
    <form *ngIf="form"
          [formGroup]="form.controls.answers"
          (ngSubmit)="submit()">
      <section class="content">
        <div formArrayName="Questions"
             *ngFor="let question of kbaConversation.questionSet.Questions; let questionIndex = index"
             class="layout padding-bottom">
          <h3 class="question">{{question.Text.Statement}}</h3>
          <p *ngIf="question.HelpText && question.HelpText.Statement"
             class="hint">
            {{question.HelpText.Statement}}
          </p>
          <div [formGroupName]="questionIndex">
            <mat-radio-group [formControl]="form.get('answers.Questions.' + questionIndex + '.Choices.0.Choice')"
                             class="flex column">
              <mat-radio-button *ngFor="let choice of question.Choices"
                                color="primary"
                                [value]="choice.ChoiceId">
                {{choice.Text.Statement}}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </section>
      <footer class="footer">
        <button mat-flat-button
                type="submit"
                color="primary"
                [disabled]="!form?.valid || submitSub || !submitEnabled">Continue</button>
      </footer>
    </form>
  </article>
</ifc-app-scroll-container>
